import React, { useMemo } from "react";
import { EChartsOption } from "echarts";
import ReactEchart from "../../../../../../molecules/ReactEchart";
import { setRenewalTrendsData } from "../../../utilis";
import "./index.css";

const StackedBarChart = React.memo((props: any) => {
  const { renewalsData } = props;

  const options = useMemo<EChartsOption>(
    () => ({
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
      },
      legend: {
        top: "2%",
        left: "center",
        itemWidth: 12,
        itemHeight: 12,
        textStyle: { fontSize: 14, color: "#666", padding: [0, 12, 0, 12] },
        itemGap: 30,
        data: ["Accepted", "Declined", "Pending Renewals"],
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "5%",
        containLabel: true,
      },
      
      xAxis: {
        type: "category",
        data: [
          "JAN",
          "FEB",
          "MAR",
          "APR",
          "MAY",
          "JUN",
          "JUL",
          "AUG",
          "SEP",
          "OCT",
          "NOV",
          "DEC",
        ],
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: { fontSize: 12, color: "#666" },
      },
      yAxis: {
        type: "value",
        splitLine: { lineStyle: { type: "dashed", color: "#ddd" } },
        axisLabel: { show: false },
      },

      series: setRenewalTrendsData(renewalsData?.result),
    }),
    [renewalsData?.result]
  );

  return (
    <div className="stacked-bar-container">
      <ReactEchart
        options={options}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
});

export default StackedBarChart;
